import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, provideAppInitializer, provideZonelessChangeDetection, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, Routes, withHashLocation } from '@angular/router';
import { AuthHttpInterceptor, provideAuth0 } from '@auth0/auth0-angular';
import { EntLoaderModule } from '@ng/ent-components/ent-loader';
import { EntUtilitiesModule, EntRestClientService, EntClipboardService, EntWindowRefService } from '@ng/ent-utilities';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { PolicyDetailsComponent } from './app/contract/policy-details/policy-details.component';
import { OutstandingRequirementsComponent } from './app/contract/outstanding-requirements/outstanding-requirements.component';
import { AnalyticsAppService } from './app/shared/services/analytics.service';
import { primeAccessToken } from './app/shared/auth/silent-auth';
import { SilentAuthRetryInterceptor } from './app/shared/interceptors/silent-auth-retry.interceptor';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'contractdetails'
  },
  {
    path: 'contractdetails',
    pathMatch: 'full',
    component: PolicyDetailsComponent
  },
  {
    path: 'requirements/:contractNumber',
    pathMatch: 'full',
    component: OutstandingRequirementsComponent
  }
];

const redirectParams = new URLSearchParams(window.location.search);
const isAuthRedirectCallback =
  (redirectParams.has('code') || redirectParams.has('connect_code') || redirectParams.has('error')) &&
  redirectParams.has('state');

const shouldRedirectToHash =
  window.location.search && !window.location.hash && !isAuthRedirectCallback;

if (shouldRedirectToHash) {
  console.log("Redirecting to hash location");
  window.location.replace(`${window.location.origin}${window.location.pathname}#/contractdetails${window.location.search}`);
}

if (!shouldRedirectToHash) {
  if (environment.production) {
    if (window) {
      window.console.log = () => {
        // remove the console logs
      };
      window.console.group = () => {
        // remove the console groups
      };
    }
    enableProdMode();
  }

  bootstrapApplication(AppComponent, {
    providers: [
      provideZonelessChangeDetection(),
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(routes, withHashLocation()),
      importProvidersFrom(EntLoaderModule),
      importProvidersFrom(EntUtilitiesModule),
      EntRestClientService,
      EntClipboardService,
      EntWindowRefService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: SilentAuthRetryInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthHttpInterceptor,
        multi: true,
      },
      provideAuth0({
        ...environment.auth,
        httpInterceptor: {
          allowedList: [environment.serviceUrls.apiAuthUrl, environment.serviceUrls.sfsAuthUrl],
        }
      }),
      provideAppInitializer(primeAccessToken),
      AnalyticsAppService,
    ],
  }).catch(_err =>
    console.log('some error')
  );
}
